import { ajaxor0, ajaxor4 } from '../common/basic';

export default props=>{

    function deleteThisContent() {
        ajaxor4({
            url: "/inspiration/delete/" + props.me.id,
            callback: callback,
        });

        function callback(rd) {
            if (rd == undefined) return;
            console.log(rd);
            alert(rd.status);
            location.href = "/community/list";
        }
    }
    return (<div className="">
    <style jsx>{`
.message1{ margin: 30px 70px; }
`}</style>
    <div className="message1">
        게시글을 삭제하시겠습니까?
    </div>
    <div className="centered-black-button mouse-aa" onClick={()=>{
        props.hide();
        deleteThisContent();
        console.log("call AJAX: 게시글삭제하기");
    }}>확인</div>
    <br />

</div>);
}
